export default "__VITE_ASSET__hOplnB1b__"